function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from 'react';
import { useIoContext } from "../../contexts";
import styles from "./VideoPlayer.module.scss";
import { getVideoSource, videoPlayerBorderRadius, VideoSource } from "./VideoPlayer.utils";
import LoomPlayer from "./LoomPlayer/LoomPlayer";
import { extractReactPlayerVideoName } from "../AgreementStudio/IntroVideo/IntroVideoModal/IntroVIdeoModal.utils";
import cn from 'classnames';
const VideoPlayer = _ref => {
  let {
    onError,
    url,
    onReady,
    height,
    width = '100%',
    roundedCorners = true
  } = _ref;
  const {
    ReactPlayer
  } = useIoContext();
  const videoSource = getVideoSource(new URL(url));
  const isVimeo = videoSource === VideoSource.VIMEO;
  const borderedVideoStyle = {
    borderRadius: videoPlayerBorderRadius,
    overflow: 'hidden'
  };
  const vimeoConfigs = {
    style: {
      backgroundColor: 'black'
    },
    vimeo: {
      playerOptions: {
        playsinline: 1
      }
    }
  };
  if (videoSource === VideoSource.LOOM) {
    return /*#__PURE__*/React.createElement(LoomPlayer, {
      url: url,
      onReady: onReady,
      onError: onError,
      roundedCorners: roundedCorners,
      width: width,
      height: height
    });
  }
  const onVideoPlayerReady = reactPlayer => {
    const videoName = extractReactPlayerVideoName(url, reactPlayer);
    onReady === null || onReady === void 0 || onReady({
      videoName
    });
  };
  return /*#__PURE__*/React.createElement(ReactPlayer, {
    controls: true,
    height: height,
    width: width,
    url: url,
    onError: onError
    // https://github.com/cookpete/react-player/issues/1396#issuecomment-1072876117
    ,
    disableDeferredLoading: true,
    config: {
      vimeo: {
        playerOptions: vimeoConfigs.vimeo
      }
    },
    onReady: onVideoPlayerReady,
    style: _objectSpread(_objectSpread({}, roundedCorners ? borderedVideoStyle : {}), isVimeo ? vimeoConfigs.style : {}),
    className: cn(isVimeo && styles.reactPlayerVimeoFlickerFIx)
  });
};
export default VideoPlayer;